/**
 * 다시보기 중앙버튼
 */
import replayIcon from '../../../../../assets/replay.svg';
import SbsPlayerLogger from '../../../../utils/logger';

customElements.define(
  'sbs-player-center-replay',
  class extends HTMLElement {
    constructor() {
      super();
      this.visible = false;
    }

    set visible(value) {
      this._visible = value;
      this.render();
    }

    get visible() {
      return this._visible;
    }

    static get observedAttributes() {
      return [''];
    }

    async attributeChangedCallback(name, oldValue, newValue) {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    async connectedCallback() {
      try {
        this.render();
      } catch (error) {
        console.log(error);
      }
    }

    disconnectedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    adoptedCallback() {
      try {
      } catch (error) {
        console.log(error);
      }
    }

    render() {
      try {
        this.innerHTML = `<button type="button" class="videoBtn-replay" aria-label="다시보기" title="다시보기">
              <span class="iconSvg_replay">
	                <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="70" height="70" rx="35" fill="#222222" fill-opacity="0.5"/>
                      <g filter="url(#filter0_d_2429_74225)">
                      <path d="M13.7747 26.4214C12.9386 27.019 12.7498 28.1753 13.353 29.0037L18.9484 36.6886L19.0091 36.7675C19.3208 37.1507 19.775 37.3961 20.2719 37.4467C20.7689 37.4972 21.2644 37.3482 21.6482 37.0354L21.723 36.971L28.8333 30.5185L26.3121 27.7905L22.7177 31.052C23.3087 28.6987 24.5116 26.4828 26.3133 24.6687L26.5995 24.3888C32.0397 19.2179 40.5454 19.5167 45.6249 25.0685L45.8607 25.3328C50.7213 30.9239 50.343 39.4933 44.9583 44.6114L44.7006 44.8498C39.2526 49.7716 30.9323 49.3963 25.9323 43.9311C25.2399 43.1745 24.0594 43.117 23.2956 43.8028C22.5318 44.4889 22.4738 45.659 23.1662 46.4159C29.552 53.3958 40.2389 53.8852 47.2133 47.5857L47.5427 47.2804C54.3677 40.7932 54.8379 29.9888 48.6893 22.9179L48.3916 22.5843C41.9045 15.4937 30.9784 15.1007 24.0151 21.7191L23.6511 22.0756C21.2819 24.4611 19.7365 27.383 19.0207 30.4649L16.3804 26.8392C15.7772 26.011 14.6107 25.8239 13.7747 26.4214ZM28.8333 30.5185C29.5935 29.8286 29.6455 28.6588 28.9493 27.9055C28.253 27.1523 27.0724 27.1007 26.3121 27.7905L28.8333 30.5185Z" fill="white"/>
                      </g>
                      <defs>
                      <filter id="filter0_d_2429_74225" x="10" y="14" width="48" height="43" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                      <feOffset dx="1" dy="1"/>
                      <feGaussianBlur stdDeviation="2"/>
                      <feComposite in2="hardAlpha" operator="out"/>
                      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"/>
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2429_74225"/>
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2429_74225" result="shape"/>
                      </filter>
                      </defs>
                    </svg>
	                <i class="hide">다시보기</i>
                </span>
            </button>`;
        this.event();
        this.styles();
      } catch (error) {
        console.log(error);
      }
    }

    event() {
      this.querySelector('button').addEventListener('click', (event) => {
        this.dispatchEvent(new CustomEvent('button-click-replay'));
      });
    }

    styles() {
      try {
        if (this.visible) {
          this.style.display = 'block';
        } else {
          this.style.display = 'none';
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
);
